import { render, staticRenderFns } from "./PurchaseNewLicense.vue?vue&type=template&id=316c754a&scoped=true"
import script from "./PurchaseNewLicense.vue?vue&type=script&lang=js"
export * from "./PurchaseNewLicense.vue?vue&type=script&lang=js"
import style0 from "./PurchaseNewLicense.vue?vue&type=style&index=0&id=316c754a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316c754a",
  null
  
)

export default component.exports